import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import CosmicBackground from '../components/CosmicBackground';
import Watermark from '../components/Watermark';

const ZodiacSplash = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/name');
    }, 3000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <CosmicBackground showAstroChart={false}>
      <Watermark position="bottom-right" opacity={0.3} />
      
      <div className="h-screen flex items-center justify-center" data-testid="zodiac-splash">
        {/* EXACT LOGO - Background removed, pure transparent logo */}
        <div className="relative w-11/12 max-w-xl animate-fadeIn">
          <img 
            src="/taraanaya-logo-transparent.png" 
            alt="Taraanaya" 
            className="w-full"
            style={{
              filter: 'brightness(1.2) saturate(1.1)',
              opacity: 0.95
            }}
          />
        </div>

        {/* Loading indicator */}
        <div className="absolute bottom-20 left-1/2 -translate-x-1/2 flex gap-2">
          <div className="w-2 h-2 rounded-full animate-bounce bg-cyan-400" style={{animationDelay: '0s'}} />
          <div className="w-2 h-2 rounded-full animate-bounce bg-blue-500" style={{animationDelay: '0.2s'}} />
          <div className="w-2 h-2 rounded-full animate-bounce bg-purple-500" style={{animationDelay: '0.4s'}} />
        </div>
      </div>
    </CosmicBackground>
  );
};

export default ZodiacSplash;